export default __webpack_public_path__ + "static/xr_glasses-ffbbdc55247beac8d5c597350cd1c598.png";